import script from "./CheckpointView.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointView.vue?vue&type=script&setup=true&lang=js"

import "./CheckpointView.vue?vue&type=style&index=0&id=4e5de70c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5de70c"]])

export default __exports__